import React from "react";
import { useFetch } from "../../hooks/useFetch";

interface LegalDocProps {
  fileName: string;
  documentType: string;
}

const LegalDoc: React.FC<LegalDocProps> = ({ fileName, documentType }) => {
  const { data: document } = useFetch(async () => {
    const response = await fetch(`${process.env.PUBLIC_URL}/${fileName}`);
    return response.text();
  }, [fileName]);

  const formatDocument = (text: string) => {
    const lines = text.split("\n");
    const elements: React.ReactElement[] = [];

    lines.forEach((line, index) => {
      if (index === 0) return;

      // numbered section heading ("1. INTRODUCTION")
      const sectionMatch = line.match(/^(\d+)\.\s+([A-Z\s]+)$/);
      if (sectionMatch) {
        elements.push(
          <h2
            key={index}
            className="text-2xl font-semibold text-brand-cyan mt-8 mb-4 first:mt-0"
          >
            {sectionMatch[1]}. {sectionMatch[2]}
          </h2>
        );
      }
      // subheadings (ending with colon)
      else if (line.trim().endsWith(":") && line.trim().length < 50) {
        elements.push(
          <h3 key={index} className="text-lg font-semibold text-white mt-4 mb-2">
            {line.trim()}
          </h3>
        );
      }
      // regular paragraph text
      else if (line.trim().length > 0) {
        elements.push(
          <p key={index} className="text-gray-300 leading-relaxed mb-3">
            {line}
          </p>
        );
      }
      // empty lines for spacing
      else {
        elements.push(<div key={index} className="h-2" />);
      }
    });

    return elements;
  };

  return (
    <main className="bg-dark-bg min-h-screen flex flex-col items-center px-5 py-12">
      <div className="container mx-auto w-full md:w-2/3">
        <h1 className="text-4xl md:text-5xl font-semibold text-center mb-8">
          <span className="bg-gradient-text bg-clip-text text-transparent">
            Data Revival {documentType}
          </span>
        </h1>

        <div className="bg-card-bg text-white rounded-lg p-8 md:p-12 shadow-lg">
          <div className="max-w-none">{formatDocument(document ?? "")}</div>
        </div>
      </div>
    </main>
  );
};

export default LegalDoc;
